import React, { useState } from 'react';
import { ShieldCheck, Lock, Zap, CreditCard } from 'lucide-react';
export function PricingSection() {
  const [selected, setSelected] = useState<'completo' | 'basico'>('completo');
  const checkoutBasico = '#oferta';
  const checkoutCompleto = '#oferta';
  return <section id="oferta" className="bg-brand-grayLight py-16 px-5 scroll-mt-10 relative" data-id="element-187">
      <div className="max-w-xl mx-auto relative z-10" data-id="element-188">
        <div className="text-center mb-10" data-id="element-189">
          <h2 className="text-3xl md:text-4xl font-black text-slate-900 mb-4" data-id="element-190">
            Elegí tu{' '}
            <span className="text-brand-gold" data-id="element-191">sistema profesional:</span>
          </h2>
          <p className="text-sm text-slate-500 font-medium" data-id="element-192">
            Las dos opciones incluyen los 6 bonos estratégicos
          </p>
        </div>

        <button onClick={() => setSelected('basico')} className={`w-full text-left bg-white rounded-2xl p-6 mb-4 border-2 transition-all shadow-sm ${selected === 'basico' ? 'border-[#C8A96B] ring-4 ring-[#C8A96B]/10' : 'border-slate-100 hover:border-slate-200'}`} data-id="element-193">
          <div className="flex items-start justify-between gap-4" data-id="element-194">
            <div className="flex items-start gap-4" data-id="element-195">
              <div className={`w-6 h-6 rounded-full border-2 flex-shrink-0 mt-0.5 flex items-center justify-center ${selected === 'basico' ? 'border-[#C8A96B]' : 'border-slate-300'}`} data-id="element-196">
                {selected === 'basico' && <div className="w-3 h-3 rounded-full bg-[#C8A96B]" data-id="element-197" />}
              </div>
              <div data-id="element-198">
                <div className="flex items-center gap-2 mb-1" data-id="element-199">
                  <span className="text-xl" data-id="element-200">📘</span>
                  <h4 className="text-base font-black text-slate-900 uppercase" data-id="element-201">
                    MEGAPACK COLORIMETRÍA PRO™
                  </h4>
                </div>
                <p className="text-sm text-slate-500 font-medium" data-id="element-202">
                  6 tomos + 6 bonos
                </p>
              </div>
            </div>
            <div className="text-right flex-shrink-0" data-id="element-203">
              <div className="text-xs text-slate-400 line-through font-medium" data-id="element-204">
                $27.990 ARS
              </div>
              <div className="text-2xl font-black text-slate-900" data-id="element-205">$19.990</div>
            </div>
          </div>
        </button>

        <button onClick={() => setSelected('completo')} className={`w-full text-left bg-white rounded-2xl p-6 relative border-2 transition-all shadow-md ${selected === 'completo' ? 'border-[#C8A96B] ring-4 ring-[#C8A96B]/10' : 'border-slate-100 hover:border-slate-200'}`} data-id="element-206">
          <div className="flex items-start justify-between gap-4" data-id="element-207">
            <div className="flex items-start gap-4" data-id="element-208">
              <div className={`w-6 h-6 rounded-full border-2 flex-shrink-0 mt-0.5 flex items-center justify-center ${selected === 'completo' ? 'border-[#C8A96B]' : 'border-slate-300'}`} data-id="element-209">
                {selected === 'completo' && <div className="w-3 h-3 rounded-full bg-[#C8A96B]" data-id="element-210" />}
              </div>
              <div data-id="element-211">
                <div className="flex items-center gap-2 mb-2" data-id="element-212">
                  <span className="text-xl" data-id="element-213">🏆</span>
                  <h4 className="text-base font-black text-slate-900 uppercase" data-id="element-214">
                    MEGAPACK + SISTEMA FORMULACIÓN CAPILAR™
                  </h4>
                </div>
                <div className="flex flex-wrap gap-2 mb-2" data-id="element-215">
                  <span className="bg-[#C8A96B] text-white text-[10px] font-black px-3 py-1 rounded-full" data-id="element-216">
                    ⭐ MÁS ELEGIDO
                  </span>
                  <span className="bg-green-100 text-green-700 text-[10px] font-black px-3 py-1 rounded-full" data-id="element-217">
                    AHORRÁS MÁS DE $20.000
                  </span>
                </div>
                <p className="text-sm text-slate-600 font-bold leading-tight" data-id="element-218">
                  6 tomos + 6 bonos + Sistema completo + Kit profesional
                </p>
              </div>
            </div>
            <div className="text-right flex-shrink-0" data-id="element-219">
              <div className="text-xs text-slate-400 line-through font-medium" data-id="element-220">
                $49.990 ARS
              </div>
              <div className="text-2xl font-black text-slate-900" data-id="element-221">$27.990 </div>
            </div>
          </div>
        </button>

        <a href={selected === 'completo' ? checkoutCompleto : checkoutBasico} className="block w-full btn-premium text-lg md:text-xl py-[20px] px-[36px] rounded-[20px] transition-all hover:scale-[1.02] text-center mt-10 mb-8 no-underline" data-id="element-222">
          {selected === 'completo' ? 'SÍ, QUIERO TODO EL SISTEMA →' : 'QUIERO MI MEGAPACK AHORA →'}
        </a>

        <div className="bg-white border border-slate-100 rounded-2xl py-6 px-6 shadow-sm" data-id="element-223">
          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-4 text-xs font-bold text-slate-500" data-id="element-224">
            <div className="flex items-center gap-2" data-id="element-225">
              <Lock size={16} className="text-[#C8A96B]" data-id="element-226" />
              Pago seguro
            </div>
            <div className="flex items-center gap-2" data-id="element-227">
              <Zap size={16} className="text-[#C8A96B]" data-id="element-228" />
              Acceso inmediato
            </div>
            <div className="flex items-center gap-2" data-id="element-229">
              <ShieldCheck size={16} className="text-[#C8A96B]" data-id="element-230" />
              Garantía 7 días
            </div>
          </div>
          <div className="flex items-center justify-center gap-3 mt-6 pt-6 border-t border-slate-50" data-id="element-231">
            <CreditCard size={18} className="text-[#C8A96B] flex-shrink-0" data-id="element-232" />
            <span className="text-xs text-slate-500 font-bold text-center" data-id="element-233">
              Pagá con tarjeta o MercadoPago de forma segura y accedé al
              material HOY
            </span>
          </div>
        </div>
      </div>
    </section>;
}